<form #mainFrm="ngForm" class="full layout-col">
  <elder-table class="flex" matSort [data]="data" [idField]="'itemId'">
    <!-- Pos number Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'context.number' | translate }}</th>
      <td mat-cell *matCellDef="let traced">{{ traced?.itemInfo?.number }}</td>
    </ng-container>

    <!-- Material Column -->
    <ng-container matColumnDef="material">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'context.material' | translate }}
      </th>
      <td mat-cell *matCellDef="let traced">
        <div class="layout-col">
          <span>{{ traced?.materialInfo?.id }} ({{ traced?.materialInfo?.searchTerm }})</span>
          <span class="mat-caption">{{ traced?.materialInfo?.path }} </span>
        </div>
      </td>
    </ng-container>

    <!-- Config Column -->
    <ng-container matColumnDef="config">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'context.config' | translate }}</th>
      <td mat-cell *matCellDef="let traced">
        <app-batch-tracing-conf-detail [spec]="traced.spec" [conf]="traced.conf">
        </app-batch-tracing-conf-detail>
      </td>
    </ng-container>
  </elder-table>

  <div class="layout-row place-start-center gap-sm p-sm">
    <button mat-button [disabled]="!mainFrm.valid" (click)="onConfirmTracingConfig()">
      {{ 'actions.ok' | translate }}
    </button>
  </div>
</form>
